import { render } from "./PendingQcms.vue?vue&type=template&id=64353c08"
import script from "./PendingQcms.vue?vue&type=script&lang=js"
export * from "./PendingQcms.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__